.kw{white-space:nowrap;}